export default "__VITE_ASSET__skAHdudN__"